// Builds performance form rows from the <template data-attandances--work-edit-target="performanceTemplate">
// declared in app/views/attendances/_form.html.erb.
//
// Two responsibilities:
//   - cloneRowFromTemplate(templateElement): mint a fresh empty row (used by 作業追加).
//   - prefillRowFromScheduleEntry(rowElement, scheduleEntry): populate the row from a
//     cached ScheduleEntry payload (used by offline hydration).
//
// Choices.js note: preselected <option selected> on the underlying <select> is honored when
// the Choices controller initializes after the element is appended to the DOM.

export function cloneRowFromTemplate(templateElement) {
  if (!templateElement) return null
  const html = templateElement.innerHTML.replace(/__INDEX__/g, Date.now())
  const wrapper = document.createElement("div")
  wrapper.innerHTML = html
  return wrapper.firstElementChild
}

export function prefillRowFromScheduleEntry(row, entry) {
  if (!row || !entry) return

  const ts = entry.time_slice || {}

  // Time slices belong to an attendance rule.
  row.dataset.attendanceRuleId = stringOrEmpty(entry.attendance_rule_id)

  preselectOption(row, '[data-performances--performance-field-target="projectPart"]', entry.project_part_id)
  preselectOption(row, '[data-performances--performance-field-target="timeSliceSelect"]', ts.name)
  preselectOption(row, '[data-performances--performance-field-target="workType"]', entry.work_type_id)
  preselectOption(row, '[data-performances--performance-field-target="tool"]', entry.tool_id)

  setNamedInput(row, '[name$="[time_slice_id]"]', entry.time_slice_id)
  setTargetValue(row, "sliceStart", entry.slice_start)
  setTargetValue(row, "sliceEnd", entry.slice_end)
  setTargetValue(row, "workTimeSpan", entry.work_time_span_in_hours)
  setTargetValue(row, "workManDays", entry.work_man_days)
  setTargetValue(row, "toolTimeSpan", entry.tool_time_span_in_hours)
  setTargetValue(row, "toolManDays", entry.tool_man_days)

  row.dataset.originalProjectPartId = stringOrEmpty(entry.project_part_id)
  row.dataset.originalTimeSliceId = stringOrEmpty(entry.time_slice_id)
  row.dataset.originalTimeSliceName = stringOrEmpty(ts.name)
  row.dataset.originalSliceStart = stringOrEmpty(entry.slice_start)
  row.dataset.originalSliceEnd = stringOrEmpty(entry.slice_end)
  row.dataset.originalWorkTimeSpan = stringOrEmpty(entry.work_time_span_in_hours)
  row.dataset.originalWorkManDays = stringOrEmpty(entry.work_man_days)
  row.dataset.originalWorkTypeId = stringOrEmpty(entry.work_type_id)
  row.dataset.originalToolId = stringOrEmpty(entry.tool_id)
  row.dataset.originalToolTimeSpan = stringOrEmpty(entry.tool_time_span_in_hours)
  row.dataset.originalToolManDays = stringOrEmpty(entry.tool_man_days)
  row.dataset.unsaved = "true"

  updateRowSummary(row)
}

function preselectOption(row, selectSelector, value) {
  const select = row.querySelector(selectSelector)
  if (!select) return
  const target = value == null ? "" : String(value)

  let matched = false
  Array.from(select.options).forEach(opt => {
    const isMatch = opt.value === target
    opt.selected = isMatch
    if (isMatch) matched = true
  })

  if (!matched && target !== "") {
    select.value = target
  }
}

function setTargetValue(row, targetName, value) {
  const el = row.querySelector(`[data-performances--performance-field-target="${targetName}"]`)
  if (el) el.value = value == null ? "" : value
}

function setNamedInput(row, selector, value) {
  const el = row.querySelector(selector)
  if (el) el.value = value == null ? "" : value
}

function stringOrEmpty(value) {
  return value == null ? "" : String(value)
}

function updateRowSummary(row) {
  const workMain = row.querySelector(".work-main")
  if (workMain) {
    const projectPartSelect = row.querySelector('[data-performances--performance-field-target="projectPart"]')
    workMain.textContent = getSelectedOptionText(projectPartSelect) || "-"
  }

  const workSub = row.querySelector(".work-sub")
  if (!workSub) return

  const timeSliceSelect = row.querySelector('[data-performances--performance-field-target="timeSliceSelect"]')
  const timeSliceText = getSelectedOptionText(timeSliceSelect) || "終日"

  const sliceStart = formatTimeForDisplay(getTargetValue(row, "sliceStart"))
  const sliceEnd = formatTimeForDisplay(getTargetValue(row, "sliceEnd"))
  const workTimeSpan = formatHoursForDisplay(getTargetValue(row, "workTimeSpan"))
  const workManDays = formatDecimalForDisplay(getTargetValue(row, "workManDays"))
  const toolTimeSpan = formatHoursForDisplay(getTargetValue(row, "toolTimeSpan"))

  workSub.textContent = `区分:${timeSliceText}／${sliceStart} 〜 ${sliceEnd} （${workTimeSpan}h／${workManDays}人／機械${toolTimeSpan}h）`
}

function getSelectedOptionText(select) {
  if (!select || select.selectedIndex < 0) return ""
  const option = select.options[select.selectedIndex]
  return option ? option.text : ""
}

function getTargetValue(row, targetName) {
  const el = row.querySelector(`[data-performances--performance-field-target="${targetName}"]`)
  return el ? el.value : ""
}

function formatTimeForDisplay(value) {
  if (!value) return "--:--"
  const match = String(value).match(/^(\d{2}:\d{2})/)
  return match ? match[1] : value
}

function formatHoursForDisplay(value) {
  if (!value) return "0.00"
  if (typeof value === "string" && value.includes(":")) {
    const [h, m] = value.split(":").map(Number)
    const total = (h || 0) + (m || 0) / 60
    return isNaN(total) ? "0.00" : total.toFixed(2)
  }
  const num = parseFloat(value)
  return isNaN(num) ? "0.00" : num.toFixed(2)
}

function formatDecimalForDisplay(value) {
  const num = parseFloat(value)
  return isNaN(num) ? "0.00" : num.toFixed(2)
}
